import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import iconGoogle from '../assets/images/login/google.svg';
import iconFacebook from '../assets/images/login/facebook.svg';
import iconApple from '../assets/images/login/apple.svg';

interface Props {
  onGoogle: (event: React.MouseEvent) => void;
  onFacebook: (event: React.MouseEvent) => void;
  onApple: (event: React.MouseEvent) => void;
}

const SocialLoginButtons = ({ onGoogle, onFacebook, onApple }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.socialLoginContainer}>
      <div className={classnames(classes.socialLoginButton, classes.socialLoginGoogle)} onClick={onGoogle}>
        <img src={iconGoogle} alt="Google" />
      </div>
      <div className={classnames(classes.socialLoginButton, classes.socialLoginFacebook)} onClick={onFacebook}>
        <img src={iconFacebook} alt="Facebook" />
      </div>
      <div className={classnames(classes.socialLoginButton, classes.socialLoginApple)} onClick={onApple}>
        <img src={iconApple} alt="Apple" />
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  socialLoginContainer: {
    display: 'flex',
  },
  socialLoginButton: {
    width: 44,
    height: 44,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    margin: '0 10px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  socialLoginGoogle: {
    backgroundColor: '#DE4A36',
    '&:hover': {
      backgroundColor: '#E25E4C',
    },
  },
  socialLoginFacebook: {
    backgroundColor: '#3A5A98',
    '&:hover': {
      backgroundColor: '#4165AA',
    },
  },
  socialLoginApple: {
    backgroundColor: '#000000',
    '&:hover': {
      backgroundColor: '#1A1A1A',
    },
  },
});

export default SocialLoginButtons;
